import { usePageCustomizable } from 'hb-react/shared/apps/PageCustomizables/hooks/usePageCustomizable';

export const useProjectsCustomName = (customName) => {
  const { menu } = usePageCustomizable('ventures');

  const moduleName =
    customName || (menu?.custom_name ? menu.custom_name : __('Projects'));

  return {
    moduleName,
    liveFeedTitle: (title) =>
      moduleName
        ? s__('LiveFeed|created a %{title}').i__({
            title,
          })
        : s__('LiveFeed|created a project %{title}').i__({
            title,
          }),
    VENTURE_FORM_INPUT_LABEL: moduleName
      ? __('%{moduleName} / Company name').i__({
          moduleName,
        })
      : I18n.t('web.ventures.ventures.form.company_name'),
    VENTURE_FORM_STAGE_AND_COMPANY_SIZE_LABEL: __(
      'Select %{moduleName} stage',
    ).i__({
      moduleName,
    }),
    VENTURE_SEARCH_LABEL: __('Search for %{moduleName}').i__({
      moduleName,
    }),
    FEED_SEARCH_ITEM_LABEL: moduleName || I18n.t('web.feed.ventures'),
    EMPTY: {
      headline: moduleName
        ? __('No %{moduleName} yet').i__({
            moduleName,
          })
        : I18n.t('web.me.profile.show.no_venture_yet'),
      label: moduleName
        ? __('Discover %{moduleName}').i__({
            moduleName,
          })
        : __('Discover Projects'),
    },
  };
};

export const withProjectsCustomName = (Component) => (props) => {
  const customModuleName = useProjectsCustomName();

  return <Component customModuleName={customModuleName} {...props} />;
};
